import React, {useEffect, useState} from 'react'
import rgbToHex from './util';

const SinglColor=({rgb,weight,index, hexColor}) => {
    console.log(hexColor);
    const [alert,setAlert] = useState(false);
    const bcg = rgb.join(',');
    const hex = rgbToHex(...rgb);
    const hexValue = `#${hexColor}`

    useEffect(()=> {
      const timeout = setTimeout(() => {
          setAlert(false);
      }, 3000)
      return () => clearTimeout (timeout);
    },[alert])
    return <article 
      className={`box  ${index > 10 && 'color-light' }`} 
    style = {{backgroundColor:`rgb(${bcg})`}}
    onClick = {() => {
        setAlert(true);
        navigator.clipboard.writeText(hexValue);
    }}
    >
        <p> {weight}%</p>
        <p> {hexValue}</p>
        {alert && <p className="alert"> copied to clipboard</p>}
         
    </article>
};

export default SinglColor;
